import { ChevronRight } from 'lucide-react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from '@/components-latest/primitives/Button'
import { EyeOff, EyeOpen } from '@/components-latest/primitives/Icons'
import Text from '@/components-latest/primitives/Text'
import { formatPrice } from '@/utils/currency.utils'

import Styles from './WalletCard.module.scss'

type Props = {
  amount: number
  currencyCode: string
  onOpen: () => void
  // When false, show “Wallet not enabled” and hide Open, Default is true.
  isEnrolled?: boolean
}

const WalletCard = ({
  amount,
  currencyCode,
  onOpen,
  isEnrolled = true
}: Props) => {
  const { t } = useTranslation()
  const [isAmountVisible, setIsAmountVisible] = useState(true)

  const amountText = isAmountVisible
    ? formatPrice(amount, currencyCode, {
        signDisplay: 'auto',
        minimumFractionDigits: 2
      })
    : '*****'

  return (
    <div className={Styles.card} data-testid="wallet-card">
      <div className={Styles.row}>
        <div className={Styles.leftSection}>
          <div className={Styles.titleRow}>
            <Text
              variant="heading-05"
              weight="semiBold"
              className={Styles.title}>
              {t('billing.wallet.title')}
            </Text>
            <span className={Styles.badge}>{t('billing.wallet.badge')}</span>
          </div>
          {isEnrolled ? (
            <Text
              variant="nextTitle-4"
              weight="extraBold"
              className={Styles.amount}>
              <button
                type="button"
                className={Styles.visibilityToggle}
                aria-label="toggle-wallet-amount-visibility"
                onClick={() => {
                  setIsAmountVisible(previous => !previous)
                }}>
                {isAmountVisible ? <EyeOpen /> : <EyeOff />}
              </button>
              {amountText}
            </Text>
          ) : (
            <Text
              variant="nextBody"
              weight="regular"
              className={Styles.notEnabled}
              data-testid="wallet-card-not-enabled">
              {t('billing.wallet.not-enabled')}
            </Text>
          )}
        </div>
        {isEnrolled && (
          <Button
            size="small"
            shape="rounded"
            className={Styles.openButton}
            onClick={onOpen}>
            {t('billing.wallet.open')}
            <ChevronRight className={Styles.arrowIcon} />
          </Button>
        )}
      </div>
    </div>
  )
}

export default WalletCard
